(function () {
  const SELECTOR = ".multicolumn-section .servicesection";
  const SWIPER_SELECTOR = ".multicolumn-list.swiper--multicolumn";

  let swiper = null;
  let ro = null;

  function getRoot() {
    return document.querySelector(SELECTOR);
  }

  function getSwiperEl(root) {
    return root ? root.querySelector(SWIPER_SELECTOR) : null;
  }

  function init(root) {
    const el = getSwiperEl(root);
    if (!el) return;

    // Guard: do not init twice
    if (swiper || el.classList.contains("swiper-initialized")) return;

    const paginationEl = el.querySelector(".swiper-pagination");
    const nextEl = el.querySelector(".swiper-button-next");
    const prevEl = el.querySelector(".swiper-button-prev");

    swiper = new Swiper(el, {
      loop: false,
      speed: 700,
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 20,
      watchOverflow: true,
      observer: true,
      observeParents: true,

      breakpoints: {
        750: { slidesPerView: 2, slidesPerGroup: 1, spaceBetween: 20 }
      },

      pagination: paginationEl
        ? { el: paginationEl, clickable: true }
        : undefined,

      navigation:
        nextEl && prevEl
          ? { nextEl, prevEl }
          : undefined
    });
  }

  function destroy(root) {
    const el = getSwiperEl(root);
    if (swiper) {
      swiper.destroy(true, true);
      swiper = null;
    }
    // Clean up in case Shopify editor left classes around
    if (el) el.classList.remove("swiper-initialized");
  }

  function mount() {
    const root = getRoot();
    if (!root) return;

    if (ro) ro.disconnect();
    ro = new ResizeObserver(([entry]) => {
      const w = entry.contentRect.width;
      const el = getSwiperEl(root);

      // Only run slider on mobile/tablet widths
      if (w < 990 && el) init(root);
      if (w >= 990) destroy(root);
    });

    ro.observe(root);
    // Kick once on load
    init(root);
  }

  // Initial load
  mount();

  // Shopify editor reloads
  document.addEventListener("shopify:section:load", mount);
  document.addEventListener("shopify:section:unload", () => {
    const root = getRoot();
    if (root) destroy(root);
    if (ro) ro.disconnect();
    ro = null;
  });
})();